// «Reabrir ticket» (Caja › Reabrir / Facturas › Sesiones) — 2026-10-14.
//
// Tras `POST Data/ReOpenMesa/{idSession}/{idMesa}` (responde `{ session }`):
//   1) El plano pinta la mesa ocupada con su sesión y su cuenta al momento.
//      El aviso de tiempo real (`mesa.changed`) de este mismo dispositivo se
//      descarta como eco, así que sin esto la mesa seguía libre (verde) hasta
//      recargar.
//   2) Quedan seleccionadas la zona y la mesa reabierta.
//   3) Al entrar en el TPV se abre su cuenta (MesaLeaseBridge consume la
//      petición con `takeMesaOpenOnTpvEntry`).
//   4) Se vuelve a pedir el plano al servidor (fuente de verdad).
import {
  getMesas,
  mesaReopened,
  setSelectedIdMesaSuccess,
  setZonaSelected,
} from "src/redux/slices/mesas";

const sameId = (a, b) => a != null && b != null && String(a) === String(b);

let pendingOpenMesaId = null;

/** Mesa cuya cuenta hay que abrir al entrar en el TPV (una sola vez). */
export function requestMesaOpenOnTpvEntry(mesaId) {
  pendingOpenMesaId = mesaId ?? null;
}

export function peekMesaOpenOnTpvEntry() {
  return pendingOpenMesaId;
}

export function takeMesaOpenOnTpvEntry() {
  const id = pendingOpenMesaId;
  pendingOpenMesaId = null;
  return id;
}

/**
 * Mesa de destino: la de la sesión devuelta (el API puede haberla movido o
 * unido a otra ocupada) o, si no viene, la elegida en el selector.
 */
export function reopenedMesaId(idMesa, session) {
  return session?.idMesa || idMesa || null;
}

/**
 * 2026-10-27 · Mensaje a mostrar cuando el servidor rechaza la reapertura (p. ej. el
 * arqueo de la sesión ya está cerrado: «El arqueo ya está cerrado — no se puede
 * reabrir este ticket…», mismo estilo que «Deshacer cobro»). El interceptor de axios
 * rechaza con el cuerpo de la respuesta (`{ message }`); se aceptan también el error
 * de axios sin normalizar y un texto plano.
 */
export function reopenErrorMessage(err, fallback = "No se pudo reabrir el ticket") {
  if (typeof err === "string" && err.trim()) return err;
  return err?.response?.data?.message || err?.message || fallback;
}

/** Thunk: aplica en el store el resultado de reabrir un ticket. */
export function applyReopenedTicket({ idMesa, session } = {}) {
  return (dispatch, getState) => {
    const targetId = reopenedMesaId(idMesa, session);
    if (!targetId) return null;
    dispatch(
      mesaReopened({
        idMesa: targetId,
        sessionId: session?.id ?? null,
        cuenta: session?.cuenta ?? null,
      }),
    );
    dispatch(setSelectedIdMesaSuccess(targetId));
    const mesa = (getState()?.mesas?.mesas || []).find((m) => sameId(m?.id, targetId));
    if (mesa?.zonaId != null) dispatch(setZonaSelected(mesa.zonaId));
    requestMesaOpenOnTpvEntry(targetId);
    dispatch(getMesas({ fresh: true }));
    return targetId;
  };
}
